define("settings/components/tax-id-banner", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.isVisible}}
    <div class="u--p__b">
      <Shared::CollapsableInfoCard
        @title={{html-safe
          (concat '<span class="u--text--md u--p__r__xs">⚠️</span>' (t "account.subscription.tax_id_banner.title"))
        }}
        class="u--m__t__0"
      >
        <p>
          {{t "account.subscription.tax_id_banner.description"}}
          <LinkTo @route="subscription.billing.tax_id" class="u--text--underline">
            {{t "account.subscription.tax_id_banner.cta"}}
          </LinkTo>
        </p>
      </Shared::CollapsableInfoCard>
    </div>
  {{/if}}
  */
  {
    "id": "h437GWuV",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[10,0],[14,0,\"u--p__b\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--m__t__0\"]],[[\"@title\"],[[28,[37,2],[[28,[37,3],[\"<span class=\\\"u--text--md u--p__r__xs\\\">⚠️</span>\",[28,[37,4],[\"account.subscription.tax_id_banner.title\"],null]],null]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"account.subscription.tax_id_banner.description\"],null]],[1,\"\\n        \"],[8,[39,5],[[24,0,\"u--text--underline\"]],[[\"@route\"],[\"subscription.billing.tax_id\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,4],[\"account.subscription.tax_id_banner.cta\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/collapsable-info-card\",\"html-safe\",\"concat\",\"t\",\"link-to\"]]",
    "moduleName": "settings/components/tax-id-banner.hbs",
    "isStrictMode": false
  });
  let TaxIdBannerComponent = _exports.default = (_class = class TaxIdBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }
    /**
     * Will be visible to users who are in a taxable region but are not currently being charged
     * and are in a region where we allow inputting a tax id
     *
     * Does not show if user has entered their tax id and it's valid.
     */
    get isVisible() {
      if (this.auth.currentAccount.hasValidTaxId || this.isEnterpriseSubscription || this.isMobileSubscription) {
        return false;
      }
      return this.address.showAddressBanner && this.address.shouldDisplayTaxAmount;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TaxIdBannerComponent);
});